module.exports = __webpack_public_path__ + "static/TradeGothicLTPro-Light-0333fd528c8f19014047ef00e5c01b0d.woff2";